import React, { useCallback } from 'react'
import api from 'api/api'
import AnswerButtons from 'components/answers/AnswerButtons'
import QuickUpvalueButton from 'components/votes/buttons/QuickUpvalueButton'
import useCachedAnswer from 'refactor/hooks/api/useCachedAnswer'
import { cacheAnswer, getCachedAnswer } from 'state/cache'

// Music's sentiment on an upvalue sent from a song card. While the song is
// playing the upvalue also carries the now-playing flag (upvalueQueue reads
// it from the dock snapshot), which the station's draw counts 5x.
export const MUSIC_UPVALUE_EMOJI = '🎶'

// The song's total on its card: the answer controls' value meter and breakdown.
// Shows once the post is cached (the song lists and the header hydrate it).
export function RadioSongValue({ songId }) {
    const song = useCachedAnswer(songId ? String(songId) : null)
    if (!song?.id) return null
    return <AnswerButtons answer={song} valueTestId="radio-song-value" thin valueOnly />
}

// The dock's quick upvalue on the song card: same button, same spammable taps.
export default function RadioUpvalueButton({ songId, source = 'music_header' }) {
    const resolveTarget = useCallback(async () => {
        if (!songId) return null
        let answer = getCachedAnswer(String(songId))
        if (!answer?.id) {
            answer = await api.getAnswer(songId).catch(() => null)
            if (answer?.id) cacheAnswer(answer)
        }
        return answer?.id ? { answer } : null
    }, [songId])

    return (
        <QuickUpvalueButton
            resolveTarget={resolveTarget}
            targetKey={songId ? String(songId) : null}
            source={source}
            reactionEmoji={MUSIC_UPVALUE_EMOJI}
            sentimentSource={source}
            ariaLabel="Upvalue this song"
            testId="radio-upvalue-button"
        />
    )
}
